import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../composants/SideBar/SideBar';
import UserInfo from '../composants/UserInfo/UserInfo';
import SuspensionModal from '../composants/SuspensionModal/SuspensionModal';
import { useAuth } from '../contexts/AuthContext';
import './MainLayout.css';

const MainLayout = () => {
  const { user, logout, suspensionInfo } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [unreadCommandes, setUnreadCommandes] = useState(0);

  // Permet à une sous-page de mettre à jour le compteur
  const handleNotificationUpdate = (count: number) => {
    setUnreadCommandes(count);
  };

  return (
    <div className="app-layout">
      {/* FRONT-19: Modal de suspension inévitable */}
      {suspensionInfo?.suspendu && (
        <SuspensionModal
          motif={suspensionInfo.motif}
          depuis={suspensionInfo.depuis}
          onLogout={logout}
        />
      )}
      <Sidebar
        // userName={user?.name || ''}
        // organisationName={user?.organisme || ''}
        // onLogout={() => { }}
        unreadCommandes={unreadCommandes}
        isCollapsed={isSidebarCollapsed}
        onCollapse={setIsSidebarCollapsed}
      />
      <main className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        {user && <UserInfo />}
        {/* Le contenu de la route s’affiche ici */}
        <Outlet context={{ onNotificationUpdate: handleNotificationUpdate }} />
      </main>
    </div>
  );
};

export default MainLayout;